export const CONNECT_TO_CARFAX_FORM = 'connectToCarfax'
export const CONNECT_TO_CARFAX_FORM_EMAIL_FIELD = 'email'
export const CONNECT_TO_CARFAX_FORM_CONFIRMATION_FIELD = 'confirmation'
export const CONNECT_TO_CARFAX_FORM_EMAIL_ERROR = 'Please enter your user email.'
export const CONNECT_TO_CARFAX_FORM_CONFIRMATION_ERROR = 'Please make a selection.'
export const MODAL_DESCRIPTION = 'Big O Tires uses CARFAX to provide you with the most accurate service history of your vehicle and help make it easy to give a Big O Yes to maintaining your car.'
